export default "__VITE_ASSET__Chq2tGRv__"